import { render } from "./MultiSelectList.vue?vue&type=template&id=182ddd0d&scoped=true"
import script from "./MultiSelectList.vue?vue&type=script&lang=js"
export * from "./MultiSelectList.vue?vue&type=script&lang=js"

import "./MultiSelectList.vue?vue&type=style&index=0&id=182ddd0d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182ddd0d"]])

export default __exports__